import React from "react";
import { ROUTES } from "../../data/routes";

const Menu = ({ isOpen, onSelect = () => {} }) => {
  const className = `menu rounded bg-white ${isOpen ? "--active" : ""}`;

  return (
    <div className={className}>
      <ul className="flex flex-col justify-evenly items-center text-primary text-xl font-semibold h-full">
        {ROUTES.map((route, index) => {
          const { name, to } = route;

          return (
            <li key={index}>
              <a href={to} onClick={() => onSelect(route)}>
                {name}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Menu;
